const pages = {
  gallery: {
    eyebrow: 'Momente',
    title: 'Galerie',
    intro: 'Fotos aus der Črna Kuhna — Feuer, Gerichte, Raum und Wein. Wir ergänzen sie, sobald wir sie aufnehmen.',
    ctaTitle: 'Kommen Sie an die gemeinsame Tafel',
    ctaText: 'Die Galerie vermittelt einen Eindruck, doch den Duft des Feuers und den Geschmack von Prlekija erleben Sie nur vor Ort. Reservieren Sie einen Tisch und kommen Sie.',
    filters: { all: 'Alle', fire: 'Feuer', dishes: 'Von der Speisekarte', space: 'Raum', wine: 'Wein' },
    categories: { fire: 'Feuer', dishes: 'Von der Speisekarte', space: 'Raum', wine: 'Wein' },
    empty: 'In dieser Kategorie gibt es noch keine Fotos.',
    openLabel: 'Foto öffnen',
    closeLabel: 'Schließen',
    prevLabel: 'Zurück',
    nextLabel: 'Weiter',
    photos: {
      oven: 'Der Backofen mit Feuer — das Herz unserer Küche',
      grill: 'Ein Grill mit offenem Feuer',
      carpaccio: 'Forellen-Carpaccio mit frischen Pfirsichen',
      soupNoodles: 'Hausgemachte Suppe mit Nudeln',
      pumpkinSoup: 'Cremige Kürbissuppe mit Kürbiskernöl',
      tomahawk: 'Tomahawk-Steak mit Grillbeilage',
      dessert: 'Hausgemachtes Dessert',
      preparation: 'Zubereitung eines Gerichts in der Küche',
      chandelier: 'Ein Detail des Raums — ein Kronleuchter aus grünen Flaschen',
      interior: 'Das Interieur der Črna Kuhna',
      wine: 'Eine Flasche Traminec aus dem Keller Glavinič',
      host: 'Unser Gastgeber in der Črna Kuhna mit Gerichten aus unserer Küche',
    },
    captions: {
      preparation: 'An besonderen kulinarischen Abenden begleiten uns die besten Köche Sloweniens.',
    },
  },
  menu: {
    eyebrow: 'Speisekarte',
    title: 'Saisonale Speisekarte',
    intro: 'Die Küche folgt den Jahreszeiten und dem prlekischen Boden. Die Gerichte ändern sich im Laufe des Jahres, deshalb füllen wir die Speisekarte nicht mit erfundenen Inhalten.',
    seasonalNotice: 'Die saisonale Speisekarte ändert sich',
    seasonalNoticeText: 'Prüfen Sie das aktuelle Angebot telefonisch — wir sagen Ihnen gerne, was heute auf dem Tisch steht.',
    emptyTitle: 'Die Speisekarte wird vorbereitet',
    emptyText: 'Das Angebot wird veröffentlicht, sobald es bestätigt ist. Bis dahin beraten wir Sie gerne telefonisch.',
    allergensTitle: 'Allergene und Ernährungsoptionen',
    allergensText: 'Wir geben zu jedem Gericht die Allergene an. Sagen Sie uns Allergien und Ernährungseinschränkungen, damit wir ein passendes Gericht zubereiten.',
    dietaryText: 'Für vegetarische, glutenfreie und andere Anpassungen sprechen Sie uns bitte im Voraus an.',
    pdfTitle: 'Speisekarte als PDF',
    pdfText: 'Ein Link zur PDF-Speisekarte wird hinzugefügt, sobald Sie ihn bereitstellen.',
    ctaCall: 'Für das aktuelle Angebot anrufen',
    categoriesLabel: 'Kategorien',
    loading: 'Speisekarte wird geladen …',
    error: 'Die Speisekarte kann derzeit nicht geladen werden.',
    retry: 'Erneut versuchen',
  },
  reserve: {
    eyebrow: 'Reservierung',
    title: 'Črna Kuhna',
    intro: 'Wählen Sie Datum, Uhrzeit und Personenzahl. Sie können auch telefonisch oder per E-Mail reservieren.',
    bookingTitle: 'Reservierungssystem',
    bookingText: 'Reservierungen laufen über unser Online-Reservierungssystem. Wenn Sie möchten, rufen Sie uns an oder schreiben Sie eine E-Mail.',
    bookingPending: 'Das Reservierungssystem wird vorbereitet. Bis dahin reservieren Sie bitte telefonisch oder per E-Mail.',
    bookingAreaLabel: 'Hier wird das Reservierungssystem eingebunden',
    phoneTitle: 'Telefonisch',
    phoneText: 'Am schnellsten geht es telefonisch — rufen Sie uns an, wir reservieren Ihren Tisch.',
    emailTitle: 'Per E-Mail',
    emailText: 'Schreiben Sie Datum, Uhrzeit und Personenzahl, und wir bestätigen Ihre Reservierung.',
    infoTitle: 'Gut zu wissen',
    infoItems: [
      'Für größere Gruppen bitten wir um eine Reservierung im Voraus.',
      'Sagen Sie uns Allergien und Ernährungseinschränkungen bei der Reservierung.',
      'Für besondere Anlässe informieren Sie uns im Voraus, damit wir alles vorbereiten können.',
    ],
    groupText: 'Planen Sie ein privates Abendessen oder eine größere Gruppe?',
    formTitle: 'Tisch reservieren',
    formIntro: 'Wählen Sie Datum, Uhrzeit und Personenzahl und geben Sie Ihre Daten ein. Wir bestätigen Ihre Reservierung so schnell wie möglich.',
    formName: 'Vor- und Nachname',
    formPhone: 'Telefon',
    formEmail: 'E-Mail (optional)',
    formDate: 'Datum',
    formTime: 'Uhrzeit',
    formTimePlaceholder: 'Uhrzeit wählen',
    formGuests: 'Personenzahl',
    formGuestsUnit: 'Personen',
    formNotes: 'Anmerkung (optional)',
    formNotesPlaceholder: 'Besondere Wünsche, Allergien, Anlass …',
    formSubmit: 'Tisch reservieren',
    formSending: 'Wird gesendet …',
    formSuccessTitle: 'Reservierung gesendet!',
    formSuccessText: 'Danke! Wir haben Ihre Reservierung erhalten. Wir bestätigen sie so schnell wie möglich per Telefon oder E-Mail.',
    formAnother: 'Neue Reservierung',
    formError: 'Die Reservierung konnte nicht gesendet werden. Versuchen Sie es erneut oder rufen Sie uns an.',
    formRequired: 'Bitte geben Sie Name, Telefon, Datum, Uhrzeit und Personenzahl an.',
    formCharCount: 'maximal 500 Zeichen',
  },
  story: {
    eyebrow: 'Geschichte',
    title: 'Unsere Geschichte',
    intro: 'Črna Kuhna ist aus dem Feuer, dem prlekischen Boden und dem Wunsch nach einer gemeinsamen Tafel entstanden.',
    lead: 'In der Črna Kuhna in Vinski Vrh beginnt alles mit dem Feuer im hauseigenen Backofen. Aus saisonalen Zutaten von unserem eigenen Hof und von Lieferanten aus Prlekija bereiten wir Gerichte zu, zu denen wir die Hausweine Glavinič servieren. Kommen Sie, setzen Sie sich an den Tisch und kosten Sie Prlekija.',
    fireTitle: 'Das Feuer als Ausgangspunkt',
    fireText: 'Das Kochen beginnt bei uns am Feuer. Der Backofen ist keine Kulisse, sondern das Herz der Küche — darin werden Gerichte langsam gebraten, mit Gespür für Hitze und Zeit.',
    firePhotoLabel: 'Foto — der Backofen mit Feuer',
    localTitle: 'Boden und Jahreszeiten',
    localText: 'Unser Ziel ist es, den Jahreszeiten und dem prlekischen Boden zu folgen und mit lokalen Erzeugern und Winzern zusammenzuarbeiten.',
    valuesTitle: 'Was uns wichtig ist',
    values: [
      'Wir sagen genau, was auf dem Teller ist — ohne Erfindungen.',
      'Wir respektieren die Saison und versprechen nichts, was es nicht gibt.',
      'Die Tafel ist gemeinsam: Raum für Gespräch, ein Glas und Zeit.',
    ],
    chaptersLabel: 'Kapitel',
    chaptersTitle: 'Entdecken Sie unsere Geschichte',
    chaptersText: 'Klicken Sie auf ein Kapitel — Bild und Wort erscheinen wie aus dem Feuer.',
    chaptersHint: 'Zum Öffnen klicken',
  },
  wines: {
    eyebrow: 'Weine',
    title: 'Weine und Vinski raj Glavinič',
    intro: 'Die Hausweine stammen aus den prlekischen Weinbergen, wo der Wein direkt neben dem Gericht wächst.',
    houseTitle: 'Hausweine Glavinič',
    houseText: 'Zum Essen servieren wir die Hausweine Glavinič. Wir beraten Sie zur Kombination und empfehlen ein Glas, das zu Ihrem Gericht passt.',
    tastingTitle: 'Verkostungen',
    tastingText: 'Verkostungen und geführte Weinproben werden im Voraus vereinbart. Sie lassen sich mit Speisen aus dem Backofen verbinden.',
    externalTitle: 'Weingut Glavinič',
    externalText: 'Mehr über die Weine von Glavinič finden Sie auf deren eigenen Seiten oder bei einer Suche im Internet.',
    externalCta: 'Nach Vinski raj Glavinič suchen',
    photoLabel: 'Foto — Wein, Gläser oder Weinberge',
    listTitle: 'Weinkarte',
    listIntro: 'Eine Auswahl an Weinen aus prlekischen Kellern, die zu unserer Küche passen.',
    whiteTitle: 'Weißweine',
    redTitle: 'Rotweine',
    wineryLabel: 'Winzer',
  },
  visit: {
    eyebrow: 'Besuch',
    title: 'Besuch und Kontakt',
    intro: 'Sie finden uns zwischen den prlekischen Hügeln und Weinbergen. Der Button unten öffnet die Route zu uns.',
    regionBadge: 'Jerusalemberge',
    regionTitle: 'Im Herzen der Jerusalemberge',
    regionText: 'Unsere Küche liegt in der Weinregion Jeruzalem — zwischen den Weinbergen der Jerusalemberge, direkt über Miklavž pri Ormožu. Hier sind Wein und Essen zu Hause.',
    addressTitle: 'Adresse',
    mapTitle: 'Karte',
    directionsCta: 'Route öffnen',
    phoneTitle: 'Telefon',
    emailTitle: 'E-Mail',
    hoursTitle: 'Winteröffnungszeiten',
    hoursText: 'Geöffnet von Donnerstag bis Sonntag; Montag–Mittwoch geschlossen.',
    socialTitle: 'Soziale Medien',
    socialText: 'Den Instagram-Link fügen wir hinzu, sobald Sie ihn bereitstellen.',
    groupText: 'Für größere Gruppen und private Anlässe rufen Sie uns gerne an.',
  },
  events: {
    eyebrow: 'Veranstaltungen',
    title: 'Veranstaltungen und private Abendessen',
    intro: 'Für private Abendessen, Familienfeiern und geschäftliche Treffen decken wir den Tisch passend zu Ihrem Anlass.',
    typesTitle: 'Was wir planen können',
    types: [
      'Private Abendessen am Feuer',
      'Familienfeiern und Jubiläen',
      'Geschäftstreffen und geschlossene Gruppen',
      'Verkostungen mit Weinbegleitung',
    ],
    enquiryTitle: 'Anfrage',
    enquiryText: 'Schreiben Sie uns, was Sie planen, und wir antworten mit einem Vorschlag und den Details.',
    formName: 'Vor- und Nachname',
    formEmail: 'E-Mail',
    formPhone: 'Telefon',
    formType: 'Art der Veranstaltung',
    formTypeOptions: ['Privates Abendessen', 'Familienfeier', 'Geschäftstreffen', 'Verkostung', 'Sonstiges'],
    formDate: 'Ungefähres Datum',
    formGuests: 'Personenzahl',
    formMessage: 'Nachricht',
    formMessagePlaceholder: 'Beschreiben Sie den Anlass, Ihre Wünsche und Besonderheiten …',
    formSubmit: 'Anfrage senden',
    formSending: 'Wird gesendet …',
    formSuccess: 'Danke! Ihre Anfrage wurde gesendet — wir melden uns so schnell wie möglich.',
    formError: 'Die Anfrage konnte nicht gesendet werden. Versuchen Sie es erneut oder rufen Sie uns an.',
    formRequired: 'Bitte füllen Sie die Pflichtfelder aus.',
    formCharCount: 'maximal 500 Zeichen',
  },
  gift: {
    eyebrow: 'Geschenk',
    title: 'Geschenkgutscheine',
    intro: 'Schenken Sie ein Essen in der Črna Kuhna — zur Feier, als Dank oder einfach zur Freude.',
    howTitle: 'So erhalten Sie einen Geschenkgutschein',
    howText: 'Geschenkgutscheine vereinbaren wir telefonisch oder per E-Mail. Wir sagen Ihnen, was aktuell möglich ist, und vereinbaren die Ausstellung.',
    valueTitle: 'Wert und Gültigkeit',
    valueText: 'Wert und Gültigkeit des Gutscheins vereinbaren wir beim Kauf, damit sie zu Ihrem Wunsch passen.',
    ctaTitle: 'Geschenkgutschein bestellen',
    ctaText: 'Rufen Sie uns an oder schreiben Sie eine E-Mail und wir bereiten einen Gutschein nach Ihren Wünschen vor.',
    photoLabel: 'Foto — ein Geschenkgutschein oder der Tisch',
    vouchersTitle: 'Geschenkgutschein im Wert von 50 € oder 100 €',
    vouchersText: 'Die Wahl ist einfach. Sie können den Geschenkgutschein direkt am Schanktisch im Restaurant kaufen und ihn mit Freude weitergeben — zur Feier, als Dank oder einfach zur Freude.',
    voucherName: 'Geschenkgutschein',
    voucherBuyLabel: 'Am Schanktisch im Restaurant erhältlich',
    voucherBuyNote: 'Den Gutschein erhalten Sie sofort beim Kauf am Schanktisch. Er gilt für alle Speisen und Getränke aus unserem Angebot.',
  },
  privacy: {
    eyebrow: 'Rechtliches',
    title: 'Datenschutzerklärung',
    intro: 'Wir verwenden Ihre Daten nur für den Zweck, für den Sie sie uns anvertraut haben.',
    sections: [
      { title: 'Welche Daten wir erheben', body: 'Daten, die Sie in die Formulare auf unserer Seite eingeben (zum Beispiel Name, E-Mail, Telefon und den Inhalt Ihrer Nachricht), sowie Daten, die Sie bei einer Reservierung oder Anfrage angeben.' },
      { title: 'Warum wir sie verwenden', body: 'Wir verwenden die Daten, um Ihre Anfrage zu beantworten, Ihre Reservierung durchzuführen und über Ihren Besuch zu kommunizieren.' },
      { title: 'Speicherung und Sicherheit', body: 'Wir speichern Daten nur so lange, wie es für den Zweck der Erhebung nötig ist, und schützen sie vor unbefugtem Zugriff.' },
      { title: 'Ihre Rechte', body: 'Sie haben das Recht auf Auskunft, Berichtigung und Löschung Ihrer Daten sowie auf Widerspruch gegen die Verarbeitung. Kontaktieren Sie uns, um diese Rechte auszuüben.' },
      { title: 'Cookies', body: 'Die Seite verwendet nur die für den Betrieb notwendigen Technologien und speichert Ihre Sprachauswahl.' },
    ],
    contactNote: 'Bei Fragen zum Datenschutz kontaktieren Sie uns:',
  },
  terms: {
    eyebrow: 'Rechtliches',
    title: 'Nutzungsbedingungen',
    intro: 'Mit der Nutzung dieser Seite stimmen Sie den folgenden Bedingungen zu.',
    sections: [
      { title: 'Inhalt der Seite', body: 'Die Inhalte werden nach bestem Wissen veröffentlicht und können sich ändern. Speisekarte, Öffnungszeiten und Angebot ändern sich; prüfen Sie aktuelle Informationen bei uns.' },
      { title: 'Reservierungen', body: 'Eine Reservierung ist gültig, sobald sie bestätigt wurde. Bitte informieren Sie uns bei Änderung oder Stornierung so früh wie möglich.' },
      { title: 'Externe Links', body: 'Die Seite kann Links zu externen Seiten enthalten, für deren Inhalte wir nicht verantwortlich sind.' },
      { title: 'Urheberrecht', body: 'Inhalte und Erscheinungsbild der Seite sind geschützt. Eine Nutzung ohne Erlaubnis ist nicht gestattet.' },
    ],
    contactNote: 'Bei Fragen kontaktieren Sie uns:',
  },
};

export default { pages };